import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { ImportErpOrderNFeXmlInput } from './ImportErpOrderNFeXmlInput';
import { ImportErpOrderNFeXmlOutput } from './ImportErpOrderNFeXmlOutput';

export class ImportErpOrderNFeXmlService extends HttpServiceBase {

  handle = (input: ImportErpOrderNFeXmlInput): Promise<Result<ImportErpOrderNFeXmlOutput> | null> => {
    const promise = this.http.post<Result<ImportErpOrderNFeXmlOutput>, FormData>(
      `${this.baseUrlSislogApi}/v2/order/${input.orderId}/erp-order-nfe/import-xml`,
      input.formData,
      true
    );
    return promise;
  }
}
